import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';

import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  delegations: [],
  delegation: null,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },
  typedeleg: "P",

  filters: {
    "typedeleg": "P",
    "user_target_code": "",
    "user_target_name": "",
    "user_target_firstname": "",
    "user_target_civility": "",
    "actorcode": "",

    "ipp": "",
    "hospcode": "",
    "patientname": "",
    "patientfirstname": ""
  },
  users: [],
  userFilters: { name: "", surname: "", code: "", civility: "" }

};

const slice = createSlice({
  name: 'Delegations',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.delegations = [];
    },
    // GET delegation
    getDelegationSuccess(state, action) {
      const { delegation } = action.payload;
      state.isLoading = false;
      state.delegation = delegation;
      state.error = null;

    },
    resetDeleg(state) {
      state.delegation = initialState.delegation;

    },
    // GET Delegations
    getDelegationsSuccess(state, action) {
      const { delegs, navig } = action.payload;
      state.isLoading = false;
      state.delegations = delegs;
      state.navig = navig;
    },

    getUsersDelegationSuccess(state, action) {
      const { users, navig } = action.payload;
      state.isLoading = false;
      state.users = users;
      state.navig = navig;
    },
    //  SORT & FILTER Delegations
    paginationDelegations(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    filterUserDelegation(state, action) {
      state.userFilters = action.payload;
    },
    filterDelegations(state, action) {
      state.filters = action.payload;
    },
    resetDelegations(state) {
      state.delegations = initialState.delegations;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    },
    resetUserDelegation(state) {
      state.users = initialState.users;
      state.navig = initialState.navig;
      state.userFilters = initialState.userFilters;
    },
    setTypeDelegation(state, action) {
      state.typedeleg = action.payload;
      state.delegations = [];
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  paginationDelegations,
  filterDelegations,
  resetDelegations,
  resetDeleg,
  hasError,
  setTypeDelegation,
  resetUserDelegation,
  filterUserDelegation
} = slice.actions;

// ----------------------------------------------------------------------

export function getDelegations() {
  const { delegation: { filters, navig }, all: { config } } = store.getState();
  const emptyFilter = { ...initialState.filters };

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      if (JSON.stringify(filters) === JSON.stringify(emptyFilter))
        throw new Error('Vous devez saisir plus de critères de recherche !');
      const criteres = { ...filters, actorcode: filters.actorcode.code, user_target_civility: filters.user_target_civility.code };

      const response = await axios.post(API.path, {
        criteres: { logincode: config.current.code, ...criteres },
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.SEARCHDELEG
      });

      const { data } = response;

      if (data?.delegs?.length === 0)
        throw new Error(' Aucun delegation  ne correspond aux critères sélectionnés');

      dispatch(slice.actions.getDelegationsSuccess(data));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDelegation(criteres) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADDELEG,
        criteres
      });

      const { data: { deleg } } = response;
      dispatch(slice.actions.getDelegationSuccess({ delegation: deleg }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getUsers() {
  const { delegation: { userFilters, navig } } = store.getState();
  const emptyFilter = { ...initialState.userFilters };

  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      if (JSON.stringify(userFilters) === JSON.stringify(emptyFilter))
        throw new Error('Vous devez saisir plus de critères de recherche !');
      const { data } = await axios.post(API.path, {
        action: ACTIONS.LOADUSERS,
        criteres: { ...userFilters, civilite: userFilters.civility.code },

        navig
      });

      if (data?.users?.length === 0)
        throw new Error(' Aucun utilisateur  ne correspond aux critères sélectionnés');

      dispatch(slice.actions.getUsersDelegationSuccess(data));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}



